// src/pages/Contact.js
import { useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { RxCross2 } from 'react-icons/rx';

import { CustomLoader } from '../../../services/Reducer';
import apiClient from '../../../api/apiClient';
import authServices from '../../../services/AuthServices';
import { Autocomplete, TextField } from '@mui/material';



const Edit = ({ edit, toggle_Edit, invoiceId, refreshData, AddcurrentPage }) => {
  const [selectedDates, setSelectedDates] = useState('');
  const dispatch = useDispatch();

  const loader = (display) => {
    dispatch(CustomLoader(display));
  };

  const [formData, setFormData] = useState({

    id: '',
    deviceUsername: '',
    devicePassword: '',
    mid: '',
    tid: '',
    userId: '',

  });

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };


  //************************************* Fetch invoice data when the modal opens ********************************************************
  const token = authServices.getToken();

  const fetchInvoiceData = async () => {
    if (edit && invoiceId) {
      loader('enable');

      try {
        const response = await apiClient.get(`/api/admin/device_config/${invoiceId}`, {

          headers: {
            'access_token': token,
          },

        });

        if (response.data.Status === "SUCCESS") {

          setFormData({
            id: invoiceId || '',
            deviceUsername: response.data.data.deviceUsername || '',
            devicePassword: response.data.data.devicePassword || '',
            mid: response.data.data.mid || '',
            tid: response.data.data.tid || '',
            userId: response.data.data.userId || '',
          });
        }
        else {
          console.log(response.data.message)
        }
      } catch (error) {
        console.error('catch Error :- ', error.response ? error.response.data.message : error);
      } finally {
        loader('disable');
      }
    }
  };




  //******************************************* Handle save and update the data **************************************************
  const handleSave = async () => {
    loader('enable');

    try {
      const response = await apiClient.put(`/api/admin/device_config/update`, formData, {

        headers: {
          'access_token': token,
        },
      });
      if (response.data.Status === "SUCCESS") {

      }
      else {
        console.log(response.data.message)
      }
    }
    catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      refreshData(AddcurrentPage);
      toggle_Edit();
      loader('disable');
    }
  };

  // ************************************************ Get User Data ***********************************************************
  const [data, setData] = useState([]);

  const fetchPortId = async () => {
    try {
      const response = await apiClient.get(`/api/admin/users/getByUserType?userType=user&pageNumber=0&pageSize=200`, {
        params: {
          pageNumber: 0,
          pageSize: 200,
        },
        headers: {
          'access_token': token,
        }
      }
      );
      setData(response.data.data.records);

    } catch (err) {
      console.error('Error fetching data:', err);
    }
  };

  const filteredData = Array.from(
    new Map(data.map((item) => [item.name, item])).values()
  );

  const validData = filteredData.filter((item) => item.name);


  useEffect(() => {
    fetchPortId()
    fetchInvoiceData();
  }, [invoiceId, edit]);


  return (
    <>
      {edit && (
        <div className="modal fade show d-block" id="exampleModalScrollable" tabIndex={-1} role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
          <div className="modal-dialog modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalScrollableTitle">
                  Edit device_config
                </h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={toggle_Edit} >
                  < RxCross2 />
                </button>
              </div>
              <div className="modal-body-custom">
                <form>

                  <div className='row w-100'>
                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="deviceUsername" className="label-custom">Device Username</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="deviceUsername"
                        name="deviceUsername"
                        value={formData.deviceUsername}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="spacing w-50 d-inline-block">

                      <label htmlFor="userId" className="label-custom">UserId</label>
                      <Autocomplete
                        // className={` ${errors.userId ? 'input-error' : ''}`}
                        disablePortal
                        options={validData} // Full user object
                        getOptionLabel={(option) => option.name} // Show 'name' in dropdown
                        getOptionSelected={(option, value) => option.id === value.id} // Ensure unique selection
                        renderInput={(params) => <TextField {...params} label={formData.userId} />}
                        onChange={(event, value) => {
                          if (value) {
                            setFormData({ ...formData, userId: value.id }); // Save 'id' in state
                          } else {
                            setFormData({ ...formData, userId: "" }); // Reset state
                          }
                        }}
                        // Key attribute setup using 'id'
                        renderOption={(props, option) => (
                          <li {...props} key={option.id}>
                            {option.name}
                          </li>
                        )}
                        // Scroll enable kare inline style ke sath
                        componentsProps={{
                          paper: {
                            style: {
                              maxHeight: '130px', // Dropdown ki maximum height
                              overflowY: 'auto',  // Scroll enable karega
                            },
                          },
                        }}
                      />
                      {/* {errors.portId && <span className="text-danger">{errors.portId}</span>} */}

                    </div>

                  </div>

                  <div className='row w-100'>
                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="mid" className="label-custom">MID</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="mid"
                        name="mid"
                        value={formData.mid}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="tid" className="label-custom">TID</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="tid"
                        name="tid"
                        value={formData.tid}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className='row w-100'>
                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="devicePassword" className="label-custom">Device Password</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="devicePassword"
                        name="devicePassword"
                        value={formData.devicePassword}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                </form>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-light" data-bs-dismiss="modal" onClick={toggle_Edit}>
                  Close
                </button>
                <button type="button" className="btn btn-primary" onClick={handleSave}>
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Edit;
